import { MentionImportTypesEnum } from '../../../Common/MonitorShared/enum/mention-import-types.enum';
import { MediaTypeEnum } from '../../../Common/Basic/enums/media-type.enum';
import { LicensesEnum } from '../licenses.enum';
import { SublicensesEnum } from '../sublicenses.enum';

export class TvEyesConfiguration {
    geoInclude: string[];
    geoExclude: string[];
    isArchiveProvisioned: boolean;
    isDownloadProvisioned: boolean;
}

export class GeoRestriction {
    license: LicensesEnum;
    includeCountryIds: number[];
    excludeCountryIds: number[];

    constructor(
        license: LicensesEnum,
        includeCountryIds: number[] = [],
        excludeCountryIds: number[] = []
    ) {
        this.license = license;
        this.includeCountryIds = includeCountryIds;
        this.excludeCountryIds = excludeCountryIds;
    }
}

export interface MentionSavingQuota {
    savingQuota?: number;
    additionalMentionQuota?: number;
    savingQuotaUsed: number;
    savingQuotaRemaining?: number;
    savingQuotaStart: number;
    savingQuotaEnd: number;
}

// TODO: Convert to union type of "mine" vs general models
export class MonitoringAccountConfigurationApiModel {
    // Admin endpoint will have licenses; "mine" endpoint will have media types
    licenses?: LicensesEnum[];
    sublicenses?: SublicensesEnum[];
    socialLicenses?: number[];
    mediaTypes?: MediaTypeEnum[];
    socialMediaTypes?: MediaTypeEnum[];
    taggingSearchLimit: number;
    tveyes: TvEyesConfiguration;
    burrellesAccountIds?: string[];
    hasTveyes?: boolean;
    hasTveyesArchiving?: boolean;
    hasTveyesDownloading?: boolean;
    hasCriticalMention?: boolean;
    hasFinancialTimes?: boolean;
    prominenceGroupLimit?: number;
    mentionImportTypes?: MentionImportTypesEnum[];
    hasMentionInsights: boolean;
    hasCoverageInsights: boolean;
    unsavedMentionExportLimit?: number;
    hasTVEyesFinancialPodcastOnly: boolean;
    autoSaveTopicLimit?: number;
    activeAutoSaveTopicTotal?: number;
    savingQuotaStart: number;
    savingQuotaEnd: number;
    savingQuota?: number;
    additionalMentionQuota?: number;
    savingQuotaUsed?: number;
    geoRestrictions?: GeoRestriction[];
}
